

document.addEventListener('DOMContentLoaded', function () {
  const tocContainers = document.querySelectorAll('.ez-toc-container-direction');
  const headingsToExclude = document.querySelectorAll('.cta-text h2, .cta-text h3');

  if (!tocContainers.length || !headingsToExclude.length) return;

  // Build a Set of trimmed heading texts to exclude
  const headingTextsToExclude = new Set();
  headingsToExclude.forEach(h => {
    const text = h.textContent.trim().toLowerCase();
    if (text) headingTextsToExclude.add(text);
  });
  console.log('headingTextsToExclude:', headingTextsToExclude)

  tocContainers.forEach(function (tocContainer) {
    const tocLinks = tocContainer.querySelectorAll('nav ul.ez-toc-list a.ez-toc-link');
    if (!tocLinks.length) return;

    tocLinks.forEach(function (link) {
      const linkText = link.textContent.trim().toLowerCase();
      if (headingTextsToExclude.has(linkText)) {
        console.log(linkText);
        link.parentNode.remove();
      }
    });

    const remainingTocLinks = tocContainer.querySelectorAll('nav ul.ez-toc-list a.ez-toc-link');
    if (remainingTocLinks.length === 0) {
      tocContainer.style.display = 'none';
    }
  });
});


$(document).ready(function () {
  const $tocLinks = $('.ez-toc-link');
  const $contentsBlock = $('.contents-block');
  const $ezTocContainer = $('.contents-block #ez-toc-container');
  const $mainContentArea = $('.blog-article__content');
  const $footer = $('footer');
  const headerOffset = 100;
  const stickyTopOffset = headerOffset + 20;

  if (!$tocLinks.length && !$contentsBlock.length) return;

  $tocLinks.on('click', function (e) {
    e.preventDefault();
    const targetId = $(this).attr('href');
    const $targetElement = $(targetId.startsWith('#') ? targetId : '#' + targetId.replace(/^#/, ''));
    if ($targetElement.length) {
      $('html, body').animate({
        scrollTop: $targetElement.offset().top - headerOffset
      }, 300, function () {
        history.pushState(null, null, targetId);
      });
    }
  });

  let headingOffsets = [];
  function calculateHeadingOffsets() {
    headingOffsets = $tocLinks.map(function () {
      const id = $(this).attr('href');
      const $el = $(id.startsWith('#') ? id : '#' + id.replace(/^#/, ''));
      return $el.length ? { id: id, offset: $el.offset().top } : null;
    }).get().filter(item => item !== null);
  }

  let contentsBlockOriginalTop = 0;
  let mainContentBottom = 0;
  let canBeSticky = false;

  function calculateStickyParameters() {
    if ($contentsBlock.length) {
      $contentsBlock.removeClass('sticky-toc no-sticky-toc').css('top', '');
      contentsBlockOriginalTop = $contentsBlock.offset().top;
    }
    if ($mainContentArea.length && $footer.length) {
      mainContentBottom = $footer.offset().top;
    }
    if ($ezTocContainer.length && $contentsBlock.length) {
      const tocHeight = $ezTocContainer.outerHeight();
      const viewportHeight = $(window).height();
      canBeSticky = (tocHeight + stickyTopOffset) < viewportHeight;
    } else if ($contentsBlock.length) {
      const contentsBlockHeight = $contentsBlock.outerHeight();
      const viewportHeight = $(window).height();
      canBeSticky = (contentsBlockHeight + stickyTopOffset) < viewportHeight;
    }
    if (!canBeSticky) {
      $contentsBlock.addClass('no-sticky-toc');
    }
  }

  if ($tocLinks.length) calculateHeadingOffsets();
  calculateStickyParameters();

  $(window).on('resize', function () {
    if ($tocLinks.length) calculateHeadingOffsets();
    calculateStickyParameters();
    $(window).trigger('scroll');
  });

  $(window).on('scroll', function () {
    const scrollTop = $(this).scrollTop();

    if ($tocLinks.length && headingOffsets.length) {
      const scrollTarget = scrollTop + headerOffset + 20;
      let currentId = null;
      for (let i = headingOffsets.length - 1; i >= 0; i--) {
        if (headingOffsets[i] && scrollTarget >= headingOffsets[i].offset) {
          currentId = headingOffsets[i].id;
          break;
        }
      }
      $tocLinks.removeClass('active');
      if (currentId) {
        $tocLinks.filter(function () {
          return $(this).attr('href') === currentId;
        }).addClass('active');
      }
    }

    if ($contentsBlock.length && canBeSticky) {
      const tocHeight = $ezTocContainer.length ? $ezTocContainer.outerHeight() : $contentsBlock.outerHeight();
      const stopStickyPoint = mainContentBottom - tocHeight - stickyTopOffset - 20;
      if (scrollTop >= contentsBlockOriginalTop - stickyTopOffset && scrollTop < stopStickyPoint) {
        if (!$contentsBlock.hasClass('sticky-toc')) {
          $contentsBlock.addClass('sticky-toc').css('top', stickyTopOffset + 'px');
          if ($contentsBlock.css('position') === 'fixed' && !$contentsBlock.data('placeholder-added')) {
            $('<div class="toc-placeholder"></div>').css('height', $contentsBlock.outerHeight()).insertBefore($contentsBlock);
            $contentsBlock.data('placeholder-added', true);
          }
        }
      } else {
        if ($contentsBlock.hasClass('sticky-toc')) {
          $contentsBlock.removeClass('sticky-toc').css('top', '');
          $('.toc-placeholder').remove();
          $contentsBlock.data('placeholder-added', false);
        }
      }
    } else if ($contentsBlock.hasClass('sticky-toc')) {
      $contentsBlock.removeClass('sticky-toc').css('top', '');
      $('.toc-placeholder').remove();
      $contentsBlock.data('placeholder-added', false);
    }
  });

  $(window).trigger('scroll');
});


jQuery(document).ready(function ($) {
  function getTemplateContent(e) {
    return e.closest('.template-container').find('.message-text-cnt i').text().replace(/<br\s*[\/]?>/gi, "\n");
  }
  console.log('blog-post.js')

  if (typeof Cookies === 'function') {
    var isLoggedIn = !!Cookies.get('loggedInAs');
    var sendNowButtons = $('[data-widget=sendNow]');

    if (isLoggedIn) {
      if (sendNowButtons.length > 0) {
        sendNowButtons.off('click').click(function () {
          Cookies.set('messageDraft', { message: { text: getTemplateContent($(this)) } }, { expires: 7, domain: getCookieDomain() });
          location.href = 'https://app.textmagic.com/compose/text-message';
        });
      }
    } else {
      if (sendNowButtons.length > 0) {
        sendNowButtons.off('click').click(function () {
          location.href = 'https://app.textmagic.com/register';
        });
      }
    }
  }

  var copyTextButtons = $('[data-widget=copyText]');
  if (copyTextButtons.length > 0) {
    copyTextButtons.each(function () {
      var copyTextButton = $(this);
      copyTextButton.click(function () {
        copyToClipboard(getTemplateContent(copyTextButton));
      });
    });
  }
});